import Navbar from '@/components/feature/Navbar';
import Footer from '@/pages/home/components/Footer';
import { aboutData } from '@/mocks/about';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: aboutData.title,
  description: aboutData.intro,
  about: {
    '@type': 'Organization',
    name: '爆料专区',
    description: aboutData.subtitle,
    foundingDate: '2024-03',
  },
};

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
        />
        {/* Hero Banner */}
        <section className="relative pt-20">
          <div className="relative h-[280px] md:h-[380px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20journalists%20working%20at%20desks%2C%20large%20screens%20showing%20breaking%20news%2C%20dramatic%20editorial%20lighting%2C%20high%20contrast%20black%20and%20white%20with%20subtle%20pink%20accents%2C%20professional%20atmosphere%2C%20cinematic%20composition&width=1600&height=600&seq=about-hero-banner&orientation=landscape"
              alt="关于爆料专区 - 新闻编辑室"
              title="爆料专区 - 全网独家免费吃瓜基地"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10 max-w-7xl mx-auto">
              <h1 className="text-3xl md:text-5xl font-heading font-black text-background-50 mb-3">
                <strong>{aboutData.title}</strong>
              </h1>
              <p className="text-base md:text-lg text-background-50/70 max-w-xl">
                {aboutData.subtitle}
              </p>
            </div>
          </div>
        </section>

        {/* Intro + Stats */}
        <section className="py-14 md:py-20 px-4 md:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 mb-14 md:mb-20">
              <div>
                <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-5">
                  {aboutData.intro}
                </p>
                <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
                  {aboutData.mission}
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4 md:gap-6">
                {aboutData.stats.map((stat) => (
                  <div
                    key={stat.label}
                    className="p-6 md:p-8 rounded-xl bg-background-100 text-center"
                  >
                    <p className="font-heading font-black text-3xl md:text-4xl lg:text-5xl text-primary-500 tracking-tight tabular-nums mb-2">
                      {stat.value}
                    </p>
                    <p className="text-sm text-foreground-500">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <span className="inline-block px-4 py-1.5 border border-background-300 rounded-full text-xs font-semibold text-foreground-600 mb-5 whitespace-nowrap">
                核心价值观
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950">
                我们坚持的理念
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {aboutData.values.map((v) => (
                <div
                  key={v.title}
                  className="p-7 rounded-xl bg-background-50 hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
                    <i className={`${v.icon} text-xl text-primary-500`}></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3">
                    {v.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {v.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="py-14 md:py-20 px-4 md:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <span className="inline-block px-4 py-1.5 border border-background-300 rounded-full text-xs font-semibold text-foreground-600 mb-5 whitespace-nowrap">
                核心团队
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950">
                吃瓜界的梦之队
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {aboutData.team.map((member) => (
                <div
                  key={member.name}
                  className="p-6 rounded-xl bg-background-100 text-center hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-4 rounded-full overflow-hidden border-2 border-background-50">
                    <img
                      src={member.avatar}
                      alt={member.name}
                      title={`${member.name} - ${member.role}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="font-heading font-bold text-foreground-950 mb-1 text-base">
                    {member.name}
                  </h3>
                  <p className="text-xs text-primary-500 font-semibold mb-3 whitespace-nowrap">
                    {member.role}
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {member.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Timeline */}
        <section className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <span className="inline-block px-4 py-1.5 border border-background-300 rounded-full text-xs font-semibold text-foreground-600 mb-5 whitespace-nowrap">
                发展历程
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950">
                我们一起走过的路
              </h2>
            </div>

            <div className="relative">
              <div className="absolute left-4 md:left-[50%] top-0 bottom-0 w-0.5 bg-background-300 md:-translate-x-px" />

              {aboutData.timeline.map((item, index) => (
                <div
                  key={item.year}
                  className={`relative flex items-start gap-6 md:gap-10 mb-8 md:mb-10 ${
                    index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  <div className={`hidden md:block flex-1 ${index % 2 === 0 ? 'text-right' : 'text-left'}`}>
                    <span className="text-sm font-heading font-bold text-primary-500">{item.year}</span>
                  </div>

                  <div className="relative z-10 flex-shrink-0">
                    <div className="w-4 h-4 rounded-full bg-primary-500 border-4 border-background-50" />
                  </div>

                  <div className="flex-1 bg-background-50 rounded-xl p-5 md:p-6">
                    <span className="text-sm font-heading font-bold text-primary-500 md:hidden mb-2 block">
                      {item.year}
                    </span>
                    <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                      {item.event}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-14 md:py-20 px-4 md:px-8 text-center">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-4">
              加入吃瓜大家庭
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-8 leading-relaxed">
              无论你是想提供爆料线索，还是想加入我们的记者团队，都欢迎随时联系我们
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="/"
                className="px-8 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                浏览最新爆料
              </a>
              <a
                href="#"
                className="px-8 py-3 border border-foreground-300 text-foreground-800 text-sm font-semibold rounded-full hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all whitespace-nowrap"
              >
                联系我们
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}